import * as React from "react";
const HaircutFemale4 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<title>{"coiffure f 4"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffure_f" data-name="coiffure f">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M488,211s-6-17-5-43,26-57,76-57,82,29,82,53c1,32-5,47-5,47s-3,11-3,19a37.14,37.14,0,0,1-11-24c-18,1-67,3-82-43-7,28-40,31-40,31s3.34,22.46-6,29C492,215,488,211,488,211Z"
			/>
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M641.11,254.44S664,265,662,319c0,18,30,33,36,33,0,0-37.69,48.07-95.84-7C601,329,601,320,601,320s34-20,35-62C638,257,639.22,256.88,641.11,254.44Z"
			/>
		</g>
	</svg>
);
export default HaircutFemale4;
